import { render, staticRenderFns } from "./FireCauseExternOrigin.vue?vue&type=template&id=1ccc74b5&scoped=true"
import script from "./FireCauseExternOrigin.vue?vue&type=script&lang=ts"
export * from "./FireCauseExternOrigin.vue?vue&type=script&lang=ts"
import style0 from "./FireCauseExternOrigin.vue?vue&type=style&index=0&id=1ccc74b5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccc74b5",
  null
  
)

export default component.exports